import {Text} from '@dropbox/dig-components/typography';
import {atoms, Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {ChevronDownLine, ChevronRightLine} from '@dropbox/dig-icons/assets';
import {type ReactNode, useState} from 'react';

export const WorkstreamMetricsSubworkstreamGroup = ({
  name,
  children,
}: {
  name: string;
  children: ReactNode;
}) => {
  const [isExpanded, setIsExpanded] = useState(true);

  return (
    <Box>
      <Box
        borderTop="Solid"
        borderBottom="Solid"
        borderColor="Border Subtle"
        className={atoms({backgroundColor: 'Opacity Surface'})}
      >
        <button
          type="button"
          onClick={() => setIsExpanded((prev) => !prev)}
          aria-expanded={isExpanded}
          className={atoms({display: 'flex', alignItems: 'center', width: '100%'})}
          style={{
            gap: 6,
            padding: '8px 8px',
            cursor: 'pointer',
            background: 'none',
            border: 'none',
            textAlign: 'left',
          }}
        >
          <UIIcon
            src={isExpanded ? ChevronDownLine : ChevronRightLine}
            className={atoms({color: 'Text Subtle'})}
            size="small"
          />
          <Text size="small" isBold>
            {name}
          </Text>
        </button>
      </Box>
      {isExpanded ? <Box paddingTop="8">{children}</Box> : null}
    </Box>
  );
};
